import { useState } from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { generateCard } from "@/lib/shareCard";

// Bouton "partager en story" façon Strava : génère une image 1080×1920 et ouvre le partage natif
export default function ShareStoryButton({ card, filename = "classement" }) {
  const [busy, setBusy] = useState(false);

  const share = async () => {
    setBusy(true);
    try {
      const blob = await generateCard(card);
      if (!blob) throw new Error("no blob");
      const file = new File([blob], `${filename}.png`, { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: card.title });
      } else {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.png`;
        a.click();
        URL.revokeObjectURL(url);
        toast.success("Image téléchargée — prête à partager !");
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Impossible de générer l'image de partage");
    } finally {
      setBusy(false);
    }
  };

  const accent = card?.accent || "#D4AF37";
  return (
    <button
      type="button"
      onClick={share}
      disabled={busy}
      data-testid="share-story-btn"
      aria-label="Partager"
      title="Partager"
      className="inline-flex items-center justify-center rounded-full border w-9 h-9 transition-opacity hover:opacity-75 disabled:opacity-50"
      style={{
        color: accent,
        borderColor: `${accent}66`,
        background: `${accent}1a`,
      }}
    >
      <Share2 className={`w-4 h-4 ${busy ? "animate-pulse" : ""}`} />
    </button>
  );
}
